import CancelIcon from '@mui/icons-material/Cancel';
import { Tooltip, styled } from '@mui/material';
import { useEffect, useState } from 'react';
import LogoIcon from '../atoms/LogoIcon';
import StyledChip from '../atoms/StyledChip';

const StyledDestinationChip = styled(StyledChip)({
    paddingLeft: 10,
    marginTop: 8,
});

const DestinationChip = ({ slug, destinationConfig, deleteDestination, isSaved }) => {
    const [url, setUrl] = useState(destinationConfig.baseUrl({ slug, destinationConfig }));

    useEffect(
        () => setUrl(destinationConfig.baseUrl({ slug, destinationConfig })),
        [slug, destinationConfig],
    );

    // Snowflake has no Redash preview URL - not clickable
    const hasPreview = Boolean(url);
    const isClickable = isSaved && hasPreview;

    return (
        <Tooltip title={hasPreview ? url : 'No preview available'}>
            {destinationConfig.default ? (
                <StyledDestinationChip
                    label={destinationConfig.name}
                    value={destinationConfig}
                    clickable={isClickable}
                    onClick={() => isClickable && window.open(url, '_blank')}
                    icon={<LogoIcon logo={destinationConfig.logo} />}
                />
            ) : (
                <StyledDestinationChip
                    label={destinationConfig.name}
                    value={destinationConfig}
                    clickable={isClickable}
                    onClick={() => isClickable && window.open(url, '_blank')}
                    icon={<LogoIcon logo={destinationConfig.logo} />}
                    onDelete={e => {
                        e.stopPropagation();
                        deleteDestination(destinationConfig);
                    }}
                    deleteIcon={<CancelIcon />}
                />
            )}
        </Tooltip>
    );
};

export default DestinationChip;
